/**
 *
 */
export const getOS = () => {
  if (typeof window === 'undefined') {
    return
  }

  const userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'darwin'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod']

  if (macosPlatforms.indexOf(platform) !== -1) {
    return 'MacOS'
  }
  if (iosPlatforms.indexOf(platform) !== -1) {
    return 'iOS'
  }
  if (windowsPlatforms.indexOf(platform) !== -1) {
    return 'Windows'
  }
  if (/Android/.test(userAgent)) {
    return 'Android'
  }
  if (/Linux/.test(platform)) {
    return 'Linux'
  }
}

/**
 *
 */
export const getBrowser = () => {
  if (typeof window === 'undefined') {
    return
  }
  const { userAgent } = window.navigator
  if (userAgent.search('MSIE') >= 0) {
    return 'IE'
  } else if (userAgent.search('Edg') >= 0) {
    return 'Edge'
  } else if (
    userAgent.search('Firefox') >= 0 ||
    userAgent.search('FxiOS') >= 0
  ) {
    return 'Firefox'
  } else if (userAgent.search('Opera') >= 0 || userAgent.search('OPR') >= 0) {
    return 'Opera'
  } else if (userAgent.search('MicroMessenger') >= 0) {
    return 'WeChat'
  } else if (userAgent.search('Chrome') >= 0) {
    return 'Chrome'
  } else if (
    // Chrome on iOS should be treated as Safari because it's a Safari wrapper.
    userAgent.search('CriOS') >= 0 ||
    userAgent.search('Safari') >= 0
  ) {
    return 'Safari'
  } else {
    return
  }
}

/**
 * Returns a boolean value indicating whether the current environment is a mobile web browser.
 */
export const isMobileWeb = (): boolean => {
  let check = false
  ;(function (a) {
    if (
      window.innerWidth <= 360 ||
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      // eslint-disable-next-line no-useless-escape
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    ) {
      check = true
    }
  })(navigator.userAgent || navigator.vendor)
  return check
}

export enum HostPlatform {
  MAGENTO = 'magento',
  SHOPIFY = 'shopify',
}

/**
 * Detects if the application is running within a WebView.
 * @returns {boolean} True if the application is running in a WebView, false otherwise
 */
export const isWebView = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  const userAgent = window.navigator.userAgent || ''

  // Check for common WebView indicators in the user agent
  const webViewRegex = /(WebView|wv|Version\/[\d.]+)/i

  // Check for specific platform WebView indicators
  const isAndroidWebView =
    /Android/.test(userAgent) &&
    (webViewRegex.test(userAgent) ||
      // Additional check: Android device without typical browser patterns
      (!/Samsung|Firefox|Opera|Edge/i.test(userAgent) &&
        !/Mobile Safari\/[\d.]+$/i.test(userAgent)))

  const isIOSWebView =
    /iPhone|iPad|iPod/.test(userAgent) &&
    !/Safari/.test(userAgent) &&
    !!(window as any).webkit &&
    !!(window as any).webkit.messageHandlers

  return isAndroidWebView || isIOSWebView
}

/**
 * Returns the host platform the code is running on.
 * @returns The detected host platform (MAGENTO, SHOPIFY)
 */
export const getHostPlatform = () => {
  if (typeof window === 'undefined') {
    return
  }
  // @ts-expect-error: Element.Methods is a Magento-specific property
  // coming from Prototype.js
  if (Element.Methods) {
    return HostPlatform.MAGENTO
  }
  if (window.Shopify) {
    return HostPlatform.SHOPIFY
  }
}

/**
 * Detects if the application is running within a Safari mobile browser.
 * @returns {boolean} True if the application is running in a Safari mobile browser, false otherwise
 */
export const isSafariMobile = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  const userAgent = window.navigator.userAgent || ''
  return (
    /iPhone|iPad|iPod/.test(userAgent) &&
    /Safari/.test(userAgent) &&
    /Mobile/.test(userAgent) &&
    !/CriOS/.test(userAgent) && // Exclude Chrome on iOS
    !/FxiOS/.test(userAgent)
  ) // Exclude Firefox on iOS
}
